var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ButtonGroup", { staticClass: "mb-2@large" }, [
    _c(
      "a",
      {
        staticClass: "btn w-100",
        attrs: { target: "_blank" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.goToPersonalisazion.apply(null, arguments)
          },
        },
      },
      [
        _vm._v(
          "\n    " + _vm._s(_vm._f("translate")("ttxtDesignOnline")) + "\n    "
        ),
        _c(
          "svg",
          {
            staticClass: "svg-icon ml-2 fill-white",
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 12.8 12.8",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M8.7 6.4c0 .2-.1.3-.2.5L5 10.7l-1-.9 3-3.4L4.1 3l1-.9 3.5 3.8c.1.2.1.3.1.5z",
                fill: "#3a3a39",
              },
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }